import AppButton from '@theme/components/atom/AppButton'
import AppNumber from '@theme/components/atom/AppNumber'
import Modal from '@theme/components/utils/Modal'
import _ from 'lodash'

export default {
  components: { AppButton, AppNumber, Modal },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true,
    },
    inputClass: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      value: this.item.amount,
      maxAmountInCart: 100,
    }
  },
  async mounted() {
    const product = await this.$store.dispatch('product/LOAD_PRODUCTS', { ids: [this.item.id] }, { root: true })

    this.maxAmountInCart =
      product[0].content && product[0].content.max_cart_quantity ? product[0].content.max_cart_quantity : 100
  },
  created: function() {
    this.debouncedUpdate = _.debounce(this.updateBackend, 500)
  },
  methods: {
    async updateBackend(value) {
      this.loading = true
      if (value > this.value) {
        if (await this.customAddItem()) {
          this.value += 1
        }
      } else if (value < this.value) {
        this.value -= 1
        await this.customRemoveItem()
      }
      this.loading = false
    },
    async customAddItem() {
      const data = await this.$store.dispatch('cart/ADD_TO_CART', {
        id: this.item.id,
        quantity: this.$store.state.cart.renting.rentDuration,
        newLine: true,
      })
      return data
    },
    async customRemoveItem() {
      let findItem = this.$store.state.cart.cartData.items.find(item => item.product.id === this.item.id)
      if (findItem) {
        await this.$store.dispatch('cart/REMOVE_FROM_CART', findItem)
      }
    },
    async removeItem() {
      this.loading = true
      await this.$store.dispatch('cart/REMOVE_FROM_CART', this.item)
      this.loading = false
    },
    cancelRemove() {
      this.$refs.numberInput.value = this.item.amount
    },
    startLoading(value) {
      this.loading = true
      this.debouncedUpdate(value)
    },
  },
}
